import { Message } from '@oneflowab/pomes';

export const APPLY_TO = {
  TEXT: 'text',
  TEXT_BACKGROUND: 'textBackground',
  TABLE_CELL_BACKGROUND: 'tableCellBackground',
} as const;

export const LABEL_CONFIG_BY_APPLY_TO: Record<string, Parameters<typeof Message>[0]> = {
  [APPLY_TO.TEXT]: {
    id: 'Text color',
    comment: 'The label of the editor\'s toolbar plugin that applies color to selected text.',
  },
  [APPLY_TO.TEXT_BACKGROUND]: {
    id: 'Text background color',
    comment:
      'The label of the editor\'s toolbar plugin that applies background color to selected text.',
  },
  [APPLY_TO.TABLE_CELL_BACKGROUND]: {
    id: 'Cell background color',
    comment:
      'The label of the editor\'s table toolbar plugin that applies background color to selected cell.',
  },
};

export const NODE_MATCHER_BY_TYPE = ['list-item'];

export const DEFAULT_COLOR = {
  BLACK: '#000000',
  WHITE: '#FFFFFF',
};
